const initialstate = {
    data:[],
    viewdata:[],
    docdata:[],
    datasave:[],
    dataapply:[],
    datareapply:[],
    chatdata:[],
    msgdata:[],
    savedata:[],
}

const OrgappView =  (state = initialstate, action:any)=>{
    switch (action.type){
        case 'fetch_data_success':
            return {... state, data:action.payload};
            case 'FETCH_VIEW_DATA_SUCCESS':
                return {... state, viewdata:action.payload};
                case 'VIEW_DATA_SUCCESS':
                return {... state, docdata:action.payload};
                case 'SAVE_DATA_SUCCESS':
                return {... state, datasave:action.payload};
                case 'APPLY_DATA_SUCCESS':
                return {... state, dataapply:action.payload};
                case 'REAPPLY_DATA_SUCCESS':
                return {... state, datareapply:action.payload};
                case 'FETCH_CHAT_DATA_SUCCESS':
                return {... state, chatdata:action.payload};
                case 'FETCH_DATA_SUCCESS_MAG':
                return {... state, msgdata:action.payload};
                case 'FETCH_SAVE_DATA_SUCCESS':
                    return {... state, savedata:action.payload};
            default :
            return state;
    }
};
export default OrgappView;